// extracted by mini-css-extract-plugin
module.exports = {"Sort":"sort_Sort__D_vUa","Switch":"sort_Switch__q_PAW","On":"sort_On__UAEYU"};